export default {
    deliveryTime: null,
    openCalendar: false,
    closeModalCalendar: false
};
